<template>
    <!--集采采购商管理-->
    <div>
        <div class="container">
            <e-search
                    count="10"
                    :data="filterInfo.data"
                    :field-list="filterInfo.fieldList"
                    @handleFilter="handleFilter"
                    @handleReset="handleReset"
            ></e-search>
        </div>
        <eui-btn type="primary" class="margin-b20" >新增协议</eui-btn>
        <div class="container">
            <tableList
                    rowKey="id"
                    :loading="false"
                    :table-data="tableData"
                    :table-label="tableLabel">
            </tableList>
        </div>
        <div class="pagination flex-end">
            <el-pagination
                    background
                    :page-sizes="[10, 20]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="queryData.pageNum"
                    :page-size="queryData.pageSize"
                    :total="queryData.pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"/>
        </div>
    </div>
</template>

<script>
  import eSearch from '../../components/common/e-search';
  import tableList from '../../components/common/e-table-list';
  export default {
    name: "index",
    components: {
      eSearch,
      tableList,
    },
    data(){
      return{
        checked:false,
        filterInfo: {
          data: {},
          fieldList: [
            { label: '协议编号:',type: 'input', value: '',},
            { label: '协议名称:',type: 'input', value: '',},
            { label: '协议甲方名称:',type: 'input', value: '',},
            { label: '供应商名称:',type: 'input', value: '',},
            // { label: '协议状态:',type: 'select', value: '',list:''},
            // { label: '协议来源:',type: 'select', value: '',list:''},
            // { label: '协议类型:',type: 'select', value: '',list:''},
           ],
        },
        tableData: [],
        tableLabel: [
          {label: '协议编号', param: '', align: 'center',},
          {label: '协议名称', param: '', align: 'center',},
          {label: '协议甲方', param: '', align: 'center',},
          {label: '供应商名称', param: '', align: 'center',},
          {label: '采购商清单', param: '', align: 'center',},
          {label: '商品清单', param: '', align: 'center',},
          {label: '开始时间', param: '', align: 'center',},
          {label: '结束时间', param: '', align: 'center',},
          {label: '协议类型', param: '', align: 'center',},
          {label: '操作', param: '', align: 'center',},
        ],
        queryData:{
          pageNum:1,
          pageSize:10,
          pageTotal:0,
        },
      }
    },
    methods:{
      handleCurrentChange(val){
        this.queryData.pageNum = val;
      },
      handleSizeChange(val){
        this.queryData.pageNum = 1;
        this.queryData.pageSize = val;
      },
      handleFilter(){},
      handleReset(){},
    },


  }
</script>

<style scoped lang="scss">

</style>